import React, {useEffect, useMemo, useRef, useState} from 'react';
import {withStyles} from "@material-ui/core/styles";
import {Lock} from "@mui/icons-material";
import SurveyOption from "./SurveyOption";
import {Collapse} from "@material-ui/core";
import SurveyGroupStatus from "./SurveyGroupStatus";

const styles = {
  root:{
    display: "flex",
    flexDirection: "column",
    borderLeft: "1px solid rgba(0,0,0,0.12)",
  },
  container:{
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid rgba(0,0,0,0.12)",
    paddingLeft: "1.25rem",
    '& > div:last-child > div:first-child > div:first-child': {
      marginBottom: "-1px",
      zIndex: 1,
    },
    '& > div:last-child > div:last-child > div:last-child > div:last-child > div:last-child': {
      borderBottom: "0",
    }
  },
  options:{
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid rgba(0,0,0,0.12)",
    '& > div': {
      borderBottom: "1px solid rgba(0,0,0,0.12)",
      borderLeft: "1px solid rgba(0,0,0,0.12)",
      marginLeft: "1.25rem",
    },
    '& > div:last-child': {
      borderBottom: "none"
    }
  },
  row:{
    display: "flex",
    gap: "0.5rem",
  },
  rowPad:{
    display: "flex",
    gap: "0.5rem",
    padding: "0.25rem"
  },
};

function SurveyGroupOption(props) {
  const { helpIndex, surveyGroup, rootGroups, startSurvey, filterName, openDataView, rootNext, isRoot=false, open:_open=isRoot, setOpen:_setOpen, classes } = props;
  const {completedSurveys, startedSurveys, completedChildren, startedChildren} = surveyGroup.info;

  const surveyCount = Object.keys(surveyGroup.surveys||{}).length
  const completed = completedSurveys + completedChildren;
  const started = startedSurveys + startedChildren;
  const groupCount = surveyCount + Object.keys(surveyGroup.children||{}).length
  const groupStatus = completed >= groupCount ? 2 : started <= 0 ? 0 : 1;

  const [__open, __setOpen] = useState(!!_open || (!!rootNext && surveyGroup?.info?.next?.id === rootNext))
  const [open, setOpen] = [__open, _setOpen || __setOpen];

  const initStatus = useRef(false);
  useEffect(() => {
    if(!initStatus.current){
      initStatus.current = true;
      return;
    }
    if(groupStatus === 2){
      setOpen(false)
    } else if(groupStatus === 1){
      setOpen(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupStatus]);

  const unlocked = useMemo(() => Object.values(surveyGroup.surveys || {}).filter(survey => !survey.locked)
    , [surveyGroup]);

  const locked = surveyCount - unlocked.length;

  return (
    <div className={classes.root}>
      {/*{isRoot ? null :*/}
        <SurveyGroupStatus
          helpIndex={helpIndex}
          surveyGroup={surveyGroup}
          startSurvey={startSurvey}
          openDataView={openDataView}
          open={open}
          setOpen={setOpen}
          completed={completed}
          started={started}
          groupCount={groupCount}
          groupStatus={groupStatus}
          isRoot={isRoot}
          rootNext={rootNext}
        />
      {/*}*/}
      <Collapse in={open}>
        {!surveyGroup.surveys || surveyCount === 0 ? null :
          <div id="groupSurveys" className={classes.options}>
            {unlocked.map((survey, i) =>
              <SurveyOption
                helpIndex={`${helpIndex}.${i+1}`}
                key={survey.id}
                survey={survey}
                startSurvey={startSurvey.bind(this, survey.id)}
                filterName={filterName}
                openDataView={openDataView}
              />
            )}
            {locked <= 0 ? null :
              <div id="lockedSurveys" className={classes.rowPad}>
                <Lock /> <span id="lockedCount">{locked}</span> locked assessment{locked > 1 ? "s" : ""}.  Complete previous assessment to unlock.
              </div>
            }
          </div>
        }
        {!surveyGroup.children || Object.keys(surveyGroup.children).length === 0 ? null :
          <div id="groupChildren" className={classes.container}>
            {Object.entries(surveyGroup.children||{}).sort((a,b) => a[1].order - b[1].order ).map(([id, child], i) =>
              <SurveyGroupOption
                helpIndex={`${helpIndex}.${i+1+surveyCount}`}
                key={id}
                surveyGroup={child}
                rootNext={rootNext}
                // open={child.name === "Personality Assessments" || child.name === "Year 2100 Assessment"}
                rootGroups={rootGroups}
                startSurvey={startSurvey}
                filterName={filterName}
                openDataView={openDataView}
                classes={classes}
              />
            )}
          </div>
        }
      </Collapse>
    </div>
  );
}

export default withStyles(styles)(SurveyGroupOption);
